import {createApp} from "vue";
import Notifications from "@kyvg/vue3-notification";
import ContactFormFlowModal from "./ContactFormFlowModal.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const CONTACT_FORM_FLOW_EMBED_SELECTOR_TRIGGER = '.vf-contact-form-flow-embed';

// There should be a better way to do this
let currentModal = null;
let currentWrapper = null;
let currentId = null;

const generateId = () => 'vf-ccf-flow-' + Math.random().toString(36).slice(2, 15)

const createWrapper = () => {
    currentWrapper = document.createElement('div');
    document.body.appendChild(currentWrapper);
    return currentWrapper;
}

const $ = window.jQuery;

const contactFormFlowFactory = {

    register: () => {
        // This is a delegated event handler, so it will work for any element that matches the selector now or in the future
        $(document.body).ready(() => {
            if (document.querySelector('.vf-contact-form-flow-embed') !== null) {
                $('.vf-contact-form-flow-embed').each(function () {
                    contactFormFlowFactory.embed({
                        franchiseId: $('.cff-data').data('franchise-id'),
                        franchiseName: $('.cff-data').data('franchise-name'),
                        pageName: $('.cff-data').data('page-name'),
                    })
                })
            }
        });
    },
    embed({franchiseId, franchiseName, pageName}) {
        // We want a unique ID for each modal just to be sure we don't have any conflicts or data mixing up between instances
        const flowId = currentId = generateId();

        currentModal = createApp(ContactFormFlowModal, {
            flowId,
            franchiseId,
            franchiseName,
            pageName
        });

        currentModal
            .use(Notifications)
            .component("v-select", vSelect)
            .mount(createWrapper());

        $('.vf-contact-form-flow-embed').append($('#' + flowId).show());

    }
};

window.vf.contactFormFlowEmbed = contactFormFlowFactory;